// extracted by mini-css-extract-plugin
export default {"label":"MedicaidTypeLabel_label__cqhgL","multiline":"MedicaidTypeLabel_multiline__m7svH","name":"MedicaidTypeLabel_name__9b0Gs"};